import { Injectable } from "@angular/core";
import { AngularFireStorage, AngularFireUploadTask } from "@angular/fire/compat/storage";
import "firebase/storage";
import { BugReport } from "src/app/settings-module/models/bug-report";
import { environment } from "src/environments/environment";
import { v4 as uuid } from "uuid";

let firebaseFolders = {
  dealSignatures: "deal_submit_signatures",
  bugReportAttachments: "bug_report_attachments",
}

@Injectable({
  providedIn: "root"
})
export class FileUploadService {

  constructor(private storage: AngularFireStorage) { }

  getFolderPathForEnv(folderPath: string) {
    return `${environment.firebase.environment + "/" + folderPath}`
  }

  upload(base64Data: string, path: string): AngularFireUploadTask {
    base64Data = base64Data.split(",")[ 1 ];
    const ref = this.storage.ref(path);
    return ref.putString(base64Data, "base64", {contentType: "image/jpg"});
  }

  uploadBuyerSignature(base64Data: string) {
    return this.upload(base64Data, `${this.getFolderPathForEnv(firebaseFolders.dealSignatures)}/${uuid()}.jpg`);
  }

  uploadCoBuyerSignature(base64Data: string) {
    return this.upload(base64Data, `${this.getFolderPathForEnv(firebaseFolders.dealSignatures)}/${uuid()}.jpg`);
  }

  uploadBugReportAttachments(attachments: File[], bugReport: BugReport) {
    attachments.forEach(attachment => {
      const ref = this.storage.ref(`${this.getFolderPathForEnv(firebaseFolders.bugReportAttachments)}/${bugReport.id}/${attachment.name}`)
      ref.put(attachment);
    })
  }

  getAttachmentsForBugReport(id: string) {
    const folderPath = `${this.getFolderPathForEnv(firebaseFolders.bugReportAttachments)}/${id}`;
    const ref = this.storage.ref(folderPath);
    return ref.listAll();
  }
}
